import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { findIndex as _findIndex } from 'lodash';
import AnimateHeight from 'react-animate-height';

import { getNameInCurrentLanguage } from 'helpers/intl';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import SimplePrompt from 'components/layout/SimplePrompt';
import TableResponsive from 'components/layout/TableResponsive';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class UserResponsibilities extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showNewPipeline: false,
      showNewLocation: false,
    };
  }

  showNewPipeline = () => {
    this.setState({ showNewPipeline: true, showNewLocation: false });
  };

  showNewLocation = () => {
    this.setState({ showNewLocation: true, showNewPipeline: false });
  };

  addPipeline = (formPropertyName, pipeline) => {
    this.setState({ showNewPipeline: false, showNewLocation: false });

    const { entity } = this.props;

    if (_findIndex(entity.getResponsibilities().getPipelines(), { id: pipeline.id }) === -1) {
      const newValue = entity
        .getResponsibilities()
        .getPipelines()
        .slice();
      newValue.push(pipeline);

      this.updateEntity('pipelines', newValue, ['responsibilities']);
    }
  };

  removePipeline = (e, pipelineId) => {
    e.preventDefault();
    e.stopPropagation();

    const { entity } = this.props;

    const newValue = entity
      .getResponsibilities()
      .getPipelines()
      .slice()
      .filter(pipeline => pipeline.getId() !== pipelineId);

    this.updateEntity('pipelines', newValue, ['responsibilities']);
  };

  addLocation = (formPropertyName, location) => {
    this.setState({ showNewPipeline: false, showNewLocation: false });

    const { entity } = this.props;

    if (_findIndex(entity.getResponsibilities().getLocations(), { id: location.location_id }) === -1) {
      const newValue = entity
        .getResponsibilities()
        .getLocations()
        .slice();
      newValue.push({ ...location, id: location.location_id });

      this.updateEntity('locations', newValue, ['responsibilities']);
    }
  };

  removeLocation = (e, locationId) => {
    e.preventDefault();
    e.stopPropagation();

    const { entity } = this.props;

    const newValue = entity
      .getResponsibilities()
      .getLocations()
      .slice()
      .filter(location => location.getId() !== locationId);

    this.updateEntity('locations', newValue, ['responsibilities']);
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      entityLoaded,
      entity,
      disabled,
      inModal,
    } = this.props;
    const { showNewPipeline, showNewLocation } = this.state;

    const locationHeaders = {
      location: messages.location,
      actions: messages.actions,
    };
    const locationRows = [];
    if (entityLoaded && entity.getResponsibilities().getLocations().length) {
      for (let i = 0; i < entity.getResponsibilities().getLocations().length; i++) {
        const location = entity.getResponsibilities().getLocations()[i];

        const rowData = {
          location: location.getName(),
          actions: [
            <SimplePrompt
              key="remove"
              iconClass="fal fa-times"
              buttonLabel={messages.remove_selection}
              onSuccess={e => this.removeLocation(e, location.getId())}
            />,
          ],
        };

        locationRows.push(rowData);
      }
    }

    const pipelineHeaders = {
      pipeline: messages.pipeline,
      actions: messages.actions,
    };
    const pipelineRows = [];
    if (entityLoaded && entity.getResponsibilities().getPipelines().length) {
      for (let i = 0; i < entity.getResponsibilities().getPipelines().length; i++) {
        const pipeline = entity.getResponsibilities().getPipelines()[i];

        const rowData = {
          pipeline: getNameInCurrentLanguage(pipeline.getName(), appIntl),
          actions: [
            <SimplePrompt
              key="remove"
              iconClass="fal fa-times"
              buttonLabel={messages.remove_selection}
              onSuccess={e => this.removePipeline(e, pipeline.getId())}
            />,
          ],
        };

        pipelineRows.push(rowData);
      }
    }

    return (
      <div className="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  <p className="form-group-title">{messages.pipelines}</p>
                  <TableResponsive headers={pipelineHeaders} rows={pipelineRows} hover />

                  <>
                    <AnimateHeight duration={500} height={showNewPipeline ? 'auto' : 0}>
                      <div className="form-group-attached">
                        <FormAutocomplete
                          label={messages.add_pipeline}
                          onChange={this.addPipeline}
                          autocompleteType="pipeline"
                          returnValueObject
                          disabled={disabled}
                        />
                      </div>
                    </AnimateHeight>
                    <AnimateHeight duration={500} height={!showNewPipeline ? 'auto' : 0}>
                      <div className="text-center">
                        <Button className="btn-rounded" onClick={this.showNewPipeline} disabled={disabled}>
                          <i className="fa fa-plus" />
                        </Button>
                      </div>
                    </AnimateHeight>
                  </>
                </div>
              </div>
            </Col>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div className="panel panel-transparent">
                <div className="panel-body">
                  <p className="form-group-title">{messages.locations}</p>
                  <TableResponsive headers={locationHeaders} rows={locationRows} hover />

                  <>
                    <AnimateHeight duration={500} height={showNewLocation ? 'auto' : 0}>
                      <div className="form-group-attached">
                        <FormAutocomplete
                          label={messages.add_location}
                          onChange={this.addLocation}
                          autocompleteType="whiteLabelLocation"
                          complete
                          returnValueObject
                          disabled={disabled}
                        />
                      </div>
                    </AnimateHeight>
                    <AnimateHeight duration={500} height={!showNewLocation ? 'auto' : 0}>
                      <div className="text-center">
                        <Button className="btn-rounded" onClick={this.showNewLocation} disabled={disabled}>
                          <i className="fa fa-plus" />
                        </Button>
                      </div>
                    </AnimateHeight>
                  </>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
UserResponsibilities.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(UserResponsibilities));
